module.exports = __webpack_public_path__ + "media/images/apple-icon-180x180-6086c05d.png";